<template>
  <div class="header">
    <div class="logo">
        <a href="/"><p class="graviaguas"><span>G</span>RAVI ÁGUAS</p></a>
    </div>
    <div class="menu">
      <ul :class="{ 'menu-open': mobileMenu }">
        <li><router-link to="/productsList" exact-active-class="active" @click.native="mobileMenu = false">Produtos</router-link></li>
        <li><router-link to="/gravacao" exact-active-class="active" @click.native="mobileMenu = false">Gravação</router-link></li>
        <!-- <li><router-link to="/fonts" exact-active-class="active" @click.native="mobileMenu = false">Fontes</router-link></li> -->
        <!-- <li><router-link to="/legislation" exact-active-class="active" @click.native="mobileMenu = false">Legislação</router-link></li> -->
        <li><router-link to="/contact" exact-active-class="active" @click.native="mobileMenu = false">Contato</router-link></li>
        <li v-if="showConfiguration" class="configuration" @click="menu()">
          <i class="fas fa-user-cog"></i>
            <span class="badge bg-warning text-dark counter" :style="{ display: counter ? 'inline' : 'none' }">
              {{ counter }}
            </span>
        </li>
        <li class="logout" @click="doLogout()" title="Sair">
          <i class="fas fa-sign-out-alt"></i>
        </li>
      </ul>
    </div>
    <div class="hamburger" @click="mobileMenu = !mobileMenu">
      <i :class="mobileMenu ? 'fas fa-times' : 'fas fa-bars'"></i>
    </div>
    <div class="menu-configuration" v-if="showMenu">
      <div class="menu-users" @click="$router.push({ name: 'users' }).catch(err => {}); showMenu = false">
        Controle de Usuários
      </div>
      <div class="products" @click="$router.push({ name: 'products' }).catch(err => {}); showMenu = false">
        Cadastro de Produtos
      </div>
      <div class="requests" @click="$router.push({ name: 'requests' }).catch(err => {}); showMenu = false">
        Pedidos de Venda
      </div>
      <div class="adverts" @click="$router.push({ name: 'adverts' }).catch(err => {}); showMenu = false">
        Anúncios
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutHeader',
  data: () => ({
    showMenu: false,
    showConfiguration: false,
    counter: '',
    counterRef: null,
    mobileMenu: false
  }),
  methods: {
    menu () {
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        this.closeMenu()
      }
    },
    closeMenu () {
      setTimeout(() => {
        this.showMenu = false
      }, 4000)
    },
    counterRequests () {
      this.counterRef = this.$firebase.database().ref('parameters/counter')
      this.counterRef.on('value', (data) => {
        this.counter = data.val()
      })
    },
    doLogout () {
      this.$firebase.auth().signOut().then(() => {
        window.uid = ''
        this.$root.$emit('Admin::hide')
        this.$router.push({ name: 'login' }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err
        })
      }).catch(error => console.error(error))
    }
  },
  created () {
    this.$root.$on('Admin::show', () => { this.showConfiguration = true })
    this.$root.$on('Admin::hide', () => { this.showConfiguration = false })

    this.counterRequests()
  },
  beforeDestroy () {
    if (this.counterRef) this.counterRef.off()
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: relative;
    z-index: 10;
    height: 80px;
    box-shadow: 0px 3px 3px 0px #b0b0b0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 40px;
    padding-right: 40px;
    .logo {
      margin-top: 15px;
      .graviaguas {
          font-family: 'Poppins', sans-serif;
          font-size: 24px;
          color: #1b9bff;
          font-weight: 400;
          letter-spacing: 1px;
          span {
            background-color: #1b9bff;
            border-radius: 5px;
            color: #e7e7e7;
            font-size: 32px;
            margin-right: 5px;
            padding: 0px 12px;
          }
      }
    }
    .menu {
      margin-top: 15px;
    }
    .menu ul li {
        display: inline-block;
    }
    .menu ul li .counter {
      position: relative;
      bottom: 10px;
      color: #ffffff;
      font-size: 11px;
    }
    .menu ul li a, .configuration, .logout {
      font-size: 18px;
      padding: 7px 15px;
      margin-left: 5px;
      border-radius: 3px;
      color: #1b9bff;
      transition: .4s;
      &:hover {
        background-color: #1b9bff;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .hamburger {
      display: none;
      font-size: 22px;
      cursor: pointer;
      color: #1b9bff;
      padding: 7px 10px;
    }
    .menu-configuration {
      position: absolute;
      right: 40px;
      top: 60px;
      transition: .4s;
      z-index: 1000;
      div {
        padding: 5px 30px;
        background-color: #1b9bff;
        color: #ffffff;
        &:hover {
          background-color: #028af1;
          cursor: pointer;
        }
      }
    }
  }
  .active {
    background-color: #1b9bff;
    color: #ffffff !important;
  }

  @media (max-width: 768px) {
    .header {
      flex-wrap: wrap;
      position: relative;
    }
    .menu ul {
      display: none;
      flex-direction: column;
      position: absolute;
      top: 80px;
      right: 0;
      background-color: #ffffff;
      box-shadow: 0px 3px 6px 0px #b0b0b0;
      z-index: 999;
      padding: 10px 0;
      min-width: 180px;
    }
    .menu ul.menu-open {
      display: flex;
    }
    .menu ul li {
      display: block !important;
      a, .configuration, .logout {
        display: block;
        margin: 2px 10px;
      }
    }
    .hamburger {
      display: block;
    }
  }

  // PARA NÃO SAIR NO FUNDO DA IMPRESSAO ERRO DO CHROME
  @media print {
      .header {
      display: none !important;
    }
  }
</style>
